import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import './StyledCard.css';

const StyledCard = ({
    children,
    className = '',
    hoverable = true,
    variant = 'default',
    ...props
}) => {
    const cardClass = `styled-card ${hoverable ? 'hoverable' : ''} ${variant} ${className}`;

    return (
        <Card className={cardClass} {...props}>
            {children}
        </Card>
    );
};

StyledCard.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    hoverable: PropTypes.bool,
    variant: PropTypes.oneOf(['default', 'instance', 'empty'])
};

export default StyledCard;